
// src/data/cards.js
export const cards = [
    { name: 'The Fool', img: '/cards/a01.jpg' },
    { name: 'The Magician', img: '/cards/a02.jpg' },
    { name: 'The High Priestess', img: '/cards/a03.jpg' },
    { name: 'The Empress', img: '/cards/a04.jpg' },
    { name: 'The Emperor', img: '/cards/a05.jpg' },
    { name: 'The Hierophant', img: '/cards/a06.jpg' },
    { name: 'The Lovers', img: '/cards/a07.jpg' },
    { name: 'The Chariot', img: '/cards/a08.jpg' },
    { name: 'Strength', img: '/cards/a09.jpg' },
    { name: 'The Hermit', img: '/cards/a10.jpg' },
    { name: 'Wheel of Fortune', img: '/cards/a11.jpg' },
    { name: 'Justice', img: '/cards/a12.jpg' },
    { name: 'The Hanged Man', img: '/cards/a13.jpg' },
    { name: 'Death', img: '/cards/a14.jpg' },
    { name: 'Temperance', img: '/cards/a15.jpg' },
    { name: 'The Devil', img: '/cards/a16.jpg' },
    { name: 'The Tower', img: '/cards/a17.jpg' },
    { name: 'The Star', img: '/cards/a18.jpg' },
    { name: 'The Moon', img: '/cards/a19.jpg' },
    { name: 'The Sun', img: '/cards/a20.jpg' },
    { name: 'Judgement', img: '/cards/a21.jpg' },
    { name: 'The World', img: '/cards/a22.jpg' },
    { name: 'Ace of Wands', img: '/cards/b01.jpg' },
    { name: 'Two of Wands', img: '/cards/b02.jpg' },
    { name: 'Three of Wands', img: '/cards/b03.jpg' },
    { name: 'Four of Wands', img: '/cards/b04.jpg' },
    { name: 'Five of Wands', img: '/cards/b05.jpg' },
    { name: 'Six of Wands', img: '/cards/b06.jpg' },
    { name: 'Seven of Wands', img: '/cards/b07.jpg' },
    { name: 'Eight of Wands', img: '/cards/b08.jpg' },
    { name: 'Nine of Wands', img: '/cards/b09.jpg' },
    { name: 'Ten of Wands', img: '/cards/b10.jpg' },
    { name: 'Page of Wands', img: '/cards/b11.jpg' },
    { name: 'Knight of Wands', img: '/cards/b12.jpg' },
    { name: 'Queen of Wands', img: '/cards/b13.jpg' },
    { name: 'King of Wands', img: '/cards/b14.jpg' },
    { name: 'Ace of Cups', img: '/cards/c01.jpg' },
    { name: 'Two of Cups', img: '/cards/c02.jpg' },
    { name: 'Three of Cups', img: '/cards/c03.jpg' },
    { name: 'Four of Cups', img: '/cards/c04.jpg' },
    { name: 'Five of Cups', img: '/cards/c05.jpg' },
    { name: 'Six of Cups', img: '/cards/c06.jpg' },
    { name: 'Seven of Cups', img: '/cards/c07.jpg' },
    { name: 'Eight of Cups', img: '/cards/c08.jpg' },
    { name: 'Nine of Cups', img: '/cards/c09.jpg' },
    { name: 'Ten of Cups', img: '/cards/c10.jpg' },
    { name: 'Page of Cups', img: '/cards/c11.jpg' },
    { name: 'Knight of Cups', img: '/cards/c12.jpg' },
    { name: 'Queen of Cups', img: '/cards/c13.jpg' },
    { name: 'King of Cups', img: '/cards/c14.jpg' },
    { name: 'Ace of Pentacles', img: '/cards/d01.jpg' },
    { name: 'Two of Pentacles', img: '/cards/d02.jpg' },
    { name: 'Three of Pentacles', img: '/cards/d03.jpg' },
    { name: 'Four of Pentacles', img: '/cards/d04.jpg' },
    { name: 'Five of Pentacles', img: '/cards/d05.jpg' },
    { name: 'Six of Pentacles', img: '/cards/d06.jpg' },
    { name: 'Seven of Pentacles', img: '/cards/d07.jpg' },
    { name: 'Eight of Pentacles', img: '/cards/d08.jpg' },
    { name: 'Nine of Pentacles', img: '/cards/d09.jpg' },
    { name: 'Ten of Pentacles', img: '/cards/d10.jpg' },
    { name: 'Page of Pentacles', img: '/cards/d11.jpg' },
    { name: 'Knight of Pentacles', img: '/cards/d12.jpg' },
    { name: 'Queen of Pentacles', img: '/cards/d13.jpg' },
    { name: 'King of Pentacles', img: '/cards/d14.jpg' },
    { name: 'Ace of Swords', img: '/cards/e01.jpg' },
    { name: 'Two of Swords', img: '/cards/e02.jpg' },
    { name: 'Three of Swords', img: '/cards/e03.jpg' },
    { name: 'Four of Swords', img: '/cards/e04.jpg' },
    { name: 'Five of Swords', img: '/cards/e05.jpg' },
    { name: 'Six of Swords', img: '/cards/e06.jpg' },
    { name: 'Seven of Swords', img: '/cards/e07.jpg' },
    { name: 'Eight of Swords', img: '/cards/e08.jpg' },
    { name: 'Nine of Swords', img: '/cards/e09.jpg' },
    { name: 'Ten of Swords', img: '/cards/e10.jpg' },
    { name: 'Page of Swords', img: '/cards/e11.jpg' },
    { name: 'Knight of Swords', img: '/cards/e12.jpg' },
    { name: 'Queen of Swords', img: '/cards/e13.jpg' },
    { name: 'King of Swords', img: '/cards/e14.jpg' },
  ];
  